import { PUT_USERS } from "../constants/actionTypes";

export function putUsers(users) {
    return {
        type: PUT_USERS,
        payload: users
    };
}
